export interface ProductDiscount {
  id?: number;
  label: string;
  percent?: number;
}

export interface ProductDiscountOption {
  id: string | number;
  label?: string;
  discountPercent?: unknown;
}

export function productDiscountFromOption(item: ProductDiscountOption | null): ProductDiscount {
  return {
    id: item ? Number(item.id) : undefined,
    label: String(item?.label ?? ''),
    percent:
      item?.discountPercent === null || item?.discountPercent === undefined
        ? undefined
        : Number(item.discountPercent)
  };
}

export function resolveProductDiscount(
  existing: ProductDiscount | undefined,
  fallback: ProductDiscount
): ProductDiscount {
  return existing ?? fallback;
}
